module.exports = __webpack_public_path__ + "static/media/sotherly-radio.516bbd28.png";


//////////////////
// WEBPACK FOOTER
// ./public/sotherly-radio.png
// module id = 192
// module chunks = 0